import { forwardRef, useRef, useState } from "react";
import { dateviewManualAccountData, ViewManualAccountconfig, viewManualAccountData } from "../Data/ViewManual.data";
import FormCreator from "../../../components/Forms/FormCreator";
import MolGrid from "../../../components/Grid/MolGrid";
import Buttons from "../../../components/ui/button/Buttons";
import { useGetPDFQuery, useLazyGetManualAccountByMemberIdQuery } from "../../../app/services/GMAP/gmapApplicationTaskListApi";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { decryptAESID } from "../../../utils/Encryption";
import { setDropDownField, setFieldParameter } from "../utils/setFieldParameter";
import { useLazyGetAllDropDownsForMemberDirectoryQuery } from "../../../app/services/common/commonApi";
import { APIUrl } from "../../../utils/API/fetchBaseQuery";

const ViewManualAccountForm = forwardRef(() => {
    const viewManualAccountRef = useRef();
    const dateviewManualAccountRef = useRef();
    const molGrifRef = useRef();
    const [dataSource, setDataSource] = useState();
    const navigate = useNavigate()
    const { id } = useParams();
    const editID = id ? decryptAESID(id, false) : 0
    const [formData, setFromData] = useState(viewManualAccountData);
    const [dateFormData, setDateFormData] = useState(dateviewManualAccountData)
    const [getManualAccountByMemberId, { isSuccess: isSuccess, isFetching: isFetching, data: manualAccountByMemberIdResponse },] = useLazyGetManualAccountByMemberIdQuery();
    const [getAllDropdownData, { isLoading: getDropdownDataIsLoading, data: getDropdownData, isSuccess: getAllDropdownDataIsSuccess }] = useLazyGetAllDropDownsForMemberDirectoryQuery();
    useEffect(() => {
        getAllDropdownData();
    }, []);

    useEffect(() => {
        if (!getDropdownDataIsLoading && getAllDropdownDataIsSuccess && getDropdownData) {
            setDropDownField(getDropdownData)
        }
    }, [getDropdownDataIsLoading, getDropdownData, getAllDropdownDataIsSuccess]);

    useEffect(() => {
        if (editID) {
            getManualAccountByMemberId(editID);
        }
    }, [editID])

    useEffect(() => {
        if (isSuccess && !isFetching && manualAccountByMemberIdResponse) {
            setFieldParameter(manualAccountByMemberIdResponse);
            const updatedDocumentList = manualAccountByMemberIdResponse?.getDocumentList?.map(documant => ({
                ...documant,
                certificateLink: `${APIUrl}/Common/getPDF?type=AttendanceCert&fileName=${documant?.documentProof}`
            }));
            setDataSource(updatedDocumentList)
        }
    }, [isSuccess, isFetching, manualAccountByMemberIdResponse]);

    const handleBack = () => {
        navigate(`/viewManualAccountList`)
    }

    return (
        <>
            <div className="row">
                {!isFetching && !getDropdownDataIsLoading &&
                    <FormCreator
                        ref={viewManualAccountRef}
                        {...formData}
                    />
                }
            </div>
            <MolGrid
                ref={molGrifRef}
                configuration={ViewManualAccountconfig}
                dataSource={dataSource}
                allowPagination={false}
            />
            <FormCreator
                ref={dateviewManualAccountRef}
                {...dateFormData}
            />
            <Buttons
                buttonText="Back"
                buttonTypeClassName="black-btn mt-4"
                onClick={() => handleBack()}
            />
        </>
    );
});

export default ViewManualAccountForm;
